export default {"src":"/_next/static/media/Arizona.ef7a887f.svg","height":786,"width":800,"blurWidth":0,"blurHeight":0};